/**
 * QNフロントバージョン
 */
export const QnFrontVersion = String(process.env.REACT_APP_QN_VERSION)

/**
 * 型定義：QNフロントバージョン
 */
export type QnFrontVersionProps = {
  version?: string
}
